import axios from '@/lib/axios';
import { PaymentTaskComment, PurchaseOrderContractTaskComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1123. 支払タスクコメント削除
 * [DELETE] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
};
const deletePaymentTaskComment = (props: Props): Promise<PaymentTaskComment> => {
  return axios.delete(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_comments/${props.id}`
  );
};

export const useDeletePaymentTaskComment = () => {
  return useMutation({
    mutationFn: deletePaymentTaskComment,
  });
};
